import { Fancybox } from '../libs/fancybox.esm.js';

const initGallery = () => {
  Fancybox.bind('[data-fancybox]');
};

export { initGallery };
